import { toast } from 'react-toastify'

export default function toastNotify (message, type) {
   switch(type) {
   case "info": toast.info(message); break;
   case "success": toast.success(message); break;
   case "warning": toast.warn(message); break;
   case "error": toast.error(message); break;
   case "default": toast(message); break;
   case "dark": toast.dark(message); break;
   default: toast(message); break;
   }
}


// WEBPACK FOOTER //
// ./src/services/toastNotify.js